<template>
  <div class="card card-info" v-if="game">
    <div class="card-body p-3">
      <div class="media">
        <span class="h1 mr-3" :class="types[game.type].icon" :style="`--fa-primary-color: ${types[game.type].colorPrimary}; --fa-secondary-color: ${types[game.type].colorSecondary};`"></span>
        <div class="media-body">
          <h5 class="mt-0">{{ config.min }}+{{ config.inc }} • {{ config.mode | cap }} • {{ config.type | cap }}</h5>
          <p>{{ new Date(gameCreated) | moment }}</p>
        </div>
      </div>
      <p class="m-0" v-for="pi in game.playerInfo" v-bind:key="pi.side"><small v-bind:class="{ 'fal': ['d', 'w'].indexOf(pi.side) > -1, 'fa': ['a', 'b'].indexOf(pi.side) > -1 }" class="mr-1 fa-circle"></small>{{ getPlayer(pi.player).username }}
        <span class="badge" v-if="getPlayer(pi.player) && getPlayer(pi.player).rating && getPlayer(pi.player).rating > 0">{{ getPlayer(pi.player).rating | floor }} <span v-if="getPlayer(pi.player).endRating" :class="{ 'text-success': getRatingDiff(pi.player).inc, 'text-danger': !getRatingDiff(pi.player).inc }">{{ getRatingDiff(pi.player).diff }}</span></span></p>
      <div v-if="game.winner" class="text-center">
        <hr>
        <strong>{{ game.result }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'GameInfo',
  props: ['game', 'config'],
  computed: {
    gameCreated() {
      if (this.game && this.game.created) {
        return this.game.created;
      }
      return Date.now();
    },
  },
  methods: {
    getRatingDiff(uid) {
      const diff = Math.floor(this.getPlayer(uid).endRating - this.getPlayer(uid).rating);
      if (diff > 0) {
        return { inc: true, diff: `+${diff}` };
      }
      return { inc: false, diff };
    },
    getPlayer(uid) {
      return this.config.players.find(p => p.uid === uid);
    },
  },
  data() {
    return {
      types: config.types,
    };
  },
};
</script>
